<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="privacy-protection">
      <Title jpn="隐私政策" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Xero Place Co., Ltd.（以下简称“公司”）要求用户提供最低限度的个人信息，以便他们能够安心地使用该网站。</span>
            <span class="text">此外，我们极其谨慎地保护提供给我们的个人信息。</span>
            <br>
            <span class="text">本公司的个人信息保护方针如下。</span>
            <span class="text">(1)公司将仅使用会员注册的个人、组织和法人的信息来开发和提供尖端的功能和服务，并将高度重视会员个人信息的保护。</span>
            <span class="text">(2) 本隐私政策仅适用于我公司提供的服务。</span>
            <span class="text">(3) 除本条款规定外，该信息不会用于任何其他目的。</span>
            <span class="text">(4) 除本条款另有规定外，我们不会向第三方披露您的信息。</span>
            <span class="text">（5）我们将定期采用本条款规定的其他方式进行适当的管理。</span>
            <span class="text">(6) 本公司可能会在未经用户许可的情况下变更隐私政策。</span>
            <span class="text">当本公司对所获取的个人信息的内容、使用方法、公开内容等进行变更时，我们会通过在本公司网站上发布公告的方式通知您，并反映在本隐私政策中，以便用户知晓该内容。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第一节 我们的隐私政策的适用范围</span>
            <span class="text">(1) 会员使用我们的服务时，适用我们的隐私政策。</span>
            <span class="text">(2)会员使用我们的服务时收集的个人信息将按照本公司的个人信息保护政策进行管理。</span>
            <span class="text">(3) 我们的个人信息保护政策仅适用于我们公司直接提供的服务，不适用于其他组织或公司提供的服务。</span>
            <span class="text">(4)使用我们的服务的风险由用户自行承担。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第 2 节. 我们个人信息的收集和使用</span>
            <span class="text">(1) 为了开发并向我们的会员提供尖端的功能和服务，我们需要用户提供一些个人信息。</span>
            <span class="text">(2) 用户有责任管理其注册邮箱地址和密码。</span>
            <span class="text">1. 定期更改密码，不建议使用姓名、出生日期、电话号码等容易被他人猜到的内容。</span>
            <span class="text">2. 请不要透露、出借或转让您的个人信息，即使是向熟人或朋友透露。</span>
            <span class="text">(3) 所收集的个人信息将仅在提供我们的服务所需的范围内使用，除以下情况外，不会向任何第三方提供。</span>
            <span class="text">1. 当信用卡公司进行调查以调查信用卡欺诈行为时。</span>
            <span class="text">2. 向会员发送广告邮件等时。</span>
            <span class="text">3. 在实现用户指定的使用目的所需的范围内，将个人信息委托给与我们签订了个人信息保密协议的分包商处理时。</span>
            <span class="text">4. 当认为有必要保护其他会员、第三方或公司的权利或财产时，会员在公司的行为违反公司的政策、公告或公司的使用条款。</span>
            <span class="text">5. 根据法院或行政机关的命令等其他法律规定要求披露个人信息时，或者出于刑事调查、消除或防止对第三方的侵权行为等需要时。</span>
            <span class="text">(4) 会员应事先同意公司按照上述规定的方式使用个人信息，且不得提出任何异议。</span>
            <span class="text">(5) 此外，在以下情况下，我们可能会与我们的业务合作伙伴共享会员的个人信息：</span>
            <span class="text">1. 有业务原因时，例如为会员提供特殊服务。在此情况下，我们会在提供信息前征求会员的同意，未经会员同意我们不会提供信息。</span>
            <span class="text">2. 创建统计材料、进行市场调查或进行数据分析时。在这种情况下，我们只会提供经过处理的信息，以便无法识别特定个人。</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.privacy-protection{
  width: 100%;
  max-width: 1200px;
  min-height: 100%;
  padding: 30px 20px 0;
  margin: 0 auto;
  .privacy-protection-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: $white!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.indent{
            padding-left: 2.6em;
            text-indent: -1.6em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
